import React from 'react';
import { useTranslation } from 'react-i18next';
import './_styles_/CashLimitsUploadResponse.css';
import { uploadResponseDataType } from '../../types';
import CashLimitConfirmationFileDownloadButton from '../buttons/CashLimitConfirmationFileDownloadButton';
import { getCashLimitUploadOutcome } from '../../utils/CashLimitUploadOutcome';

CashLimitsUploadResponse.propTypes = {
    responseData: uploadResponseDataType.isRequired,
};

function CashLimitsUploadResponse(props) {
    const {
        responseData,
    } = props;
    const { t } = useTranslation();
    const outcome = getCashLimitUploadOutcome(responseData.outcome);
    return (
        <div className={`cash-limits--upload-response ${outcome.className}`}>
            <div className="cash-limits--upload-response--outcome">
                {outcome.translate(t)}
            </div>
            {responseData.artifactId !== null && (
                <div className="cash-limits--upload-response--download-button-container">
                    <CashLimitConfirmationFileDownloadButton confirmationFileId={responseData.artifactId} />
                </div>
            )}
        </div>
    );
}

export default CashLimitsUploadResponse;
